export const imports = {
  'docs/introduction.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-introduction" */ 'docs/introduction.mdx'
    ),
  'docs/recipes.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-recipes" */ 'docs/recipes.mdx'
    ),
  'src/DateTime/DateTime.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-date-time-date-time" */ 'src/DateTime/DateTime.mdx'
    ),
}
